"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMassUpdateComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const slug_pipe_1 = require("./slug.pipe");
const version_service_1 = require("./version.service");
const user_service_1 = require("./user.service");
//VARIABLE MODELS
let AdminMassUpdateComponent = class AdminMassUpdateComponent {
    constructor(_talk, _admin, _cd, _slug, _version, _permission, _user) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._slug = _slug;
        this._version = _version;
        this._permission = _permission;
        this._user = _user;
        this.showAdEngineVersion = false; //Ad Engine dropdown to select version (SUPER USER)
        this.paramTypes = [
            "string",
            'numeric',
            "object",
            "array"
        ];
    }
    ngOnInit() {
        this.permissions = this._permission.get();
        Promise.resolve(this.adEngineVersions = this._version.getAllBiddrPlusVersions()).then(err => {
            this.updatedAdEngineVersion = this.adEngineVersions[0];
            this._cd.markForCheck();
        });
    }
    massUpdateVersion(adEngineVersion) {
        this._admin.massUpdate(adEngineVersion).then(res => {
            this._talk.broadcast(`All def files in ` + this._user.get().organization.displayName + ` updated to Biddr360 Engine version ` + adEngineVersion + `.`);
        }).catch(err => {
            this._talk.handle(err);
        });
        this._cd.markForCheck();
    }
};
exports.AdminMassUpdateComponent = AdminMassUpdateComponent;
exports.AdminMassUpdateComponent = AdminMassUpdateComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-mass-update',
        templateUrl: 'app/admin-mass-update.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        slug_pipe_1.SlugPipe,
        version_service_1.VersionService,
        permission_service_1.PermissionService,
        user_service_1.UserService])
], AdminMassUpdateComponent);
//# sourceMappingURL=admin-mass-update.component.js.map